var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "index-page"
  }, [_c('index-hero-section', {
    attrs: {
      "fields": _vm.indexPageSections.sections.index_hero_section.fields
    }
  }), _c('index-about-section', {
    attrs: {
      "fields": _vm.indexPageSections.sections.index_about_section.fields
    }
  }), _c('index-features2-section', {
    attrs: {
      "fields": _vm.indexPageSections.sections.index_features_2_section.fields
    }
  }), _c('index-divider-section', {
    attrs: {
      "fields": _vm.indexPageSections.sections.index_divider_section.fields
    }
  }), _c('index-cover-section', {
    attrs: {
      "fields": _vm.indexPageSections.sections.index_cover_section.fields
    }
  }), _c('index-text-section', {
    attrs: {
      "fields": _vm.indexPageSections.sections.index_text_section.fields
    }
  }), _c('index-features-section', {
    attrs: {
      "fields": _vm.indexPageSections.sections.index_features_section.fields
    }
  }), _c('index-divider2-section', {
    attrs: {
      "fields": _vm.indexPageSections.sections.index_divider2_section.fields
    }
  }), _c('index-text2-section', {
    attrs: {
      "fields": _vm.indexPageSections.sections.index_text2_section.fields
    }
  }), _c('index-call-to-action-section', {
    attrs: {
      "fields": _vm.indexPageSections.sections.index_call_to_action_section.fields
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }